;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import get from "lodash/get"
import { getTitle, getShowTitle } from "./profileContent"
import { resolveFullDisplayName } from "../names"

/**
 * Full display name for a user/provider pair: optional title (when the provider
 * chose to show it) + preferred-or-legal first name + preferred-or-legal last name.
 * Each name part is read from `provider.publicUser` first, then from `user`.
 * The legacy `preferredName` field is ignored (see src/lib/names/displayName.ts).
 */
const getNameToDisplay = ({ user, provider }) => {
  // Public leader V2 returns only these explicit display fields. Existing
  // provider consumers still pass profileContent, so retain that fallback.
  const title = get(provider, "title", null) ?? getTitle({ provider })
  const explicitShowTitle = get(provider, "showTitle", null)
  const showTitle =
    typeof explicitShowTitle === "boolean"
      ? explicitShowTitle
      : getShowTitle({ provider })

  const pickField = (field: string): string | null =>
    get(provider, `publicUser.${field}`, null) || get(user, field, null)

  const name = resolveFullDisplayName({
    firstName: pickField("firstName"),
    lastName: pickField("lastName"),
    preferredFirstName: pickField("preferredFirstName"),
    preferredLastName: pickField("preferredLastName"),
  })

  return showTitle && title ? `${title} ${name}`.trim() : name
}
export default getNameToDisplay
